import {createSlice} from '@reduxjs/toolkit';
import {initialFloorState} from "./initialFloorState";
import {isFloorThicknessValid} from "../../validation/form/planFormValidation";
import uuid from "react-uuid";

export const validStockFloorSizes = ["100x100", "150x100", "200x100"];

const getDrainages = (dimensions) => {
    const length = parseInt(dimensions.split("x")[0]);

    return [
        {
            id: uuid(),
            colloquialism: 'PP-Muffe',
            name: '100 mm',
            type: '100',
            diameter: 10,
            outerDiameter: 10,
            innerDiameter: 10,
            x: Math.round(length / 2),
            y: 50
        }
    ]
}

const getStockFloorStateByDimension = dimension => {
    return {
        ...initialFloorState,
        isStockFloor: true,
        selectedSize: dimension,
        drainages: getDrainages(dimension)
    };
}

const floorSlice = createSlice({
    name: 'floor',
    initialState: null,
    reducers: {
        setFloor: () => initialFloorState,
        unsetFloor: () => null,
        setStockFloor: (state) => {
            return !!state && !state.isStockFloor
                ? state
                : getStockFloorStateByDimension(validStockFloorSizes[2])
        },
        unsetStockFloor: () => null,
        setStockFloorSize: (state, action) => {
            if (!!state
                && validStockFloorSizes.includes(action.payload)
                && state.selectedSize !== action.payload
            ) {
                return getStockFloorStateByDimension(action.payload);
            }
        },
        setFloorThickness: (state, action) => {
            // action.payload should be a number (the new height)
            if (Number.isInteger(action.payload) && isFloorThicknessValid(action.payload)) {
                state.thickness = action.payload
            }
        },
        addDrainage: (state, action) => {
            // payload: { drainage }
            const {drainage} = action.payload

            state.drainages.push(drainage)
        },
        removeDrainage: (state, action) => {
            // payload: { id }
            const {id} = action.payload

            state.drainages = state.drainages.filter(d => d.id !== id)
        },
        moveDrainage: (state, action) => {
            // payload: { id, x, y }
            const {id, x, y} = action.payload
            const drainage = state.drainages.find(d => d.id === id)

            if (drainage) {
                drainage.x = x
                drainage.y = y
            }
        },
    }
})

export const {
    setFloor,
    unsetFloor,
    setStockFloor,
    unsetStockFloor,
    setStockFloorSize,
    setFloorThickness,
    addDrainage,
    removeDrainage,
    moveDrainage
} = floorSlice.actions

export default floorSlice.reducer
